type ResultFormPermissionState = {
  readonly: boolean;
  permissionLoading: boolean;
  canUpdate: boolean;
};

export const isResultFormReadOnly = ({
  readonly,
  permissionLoading,
  canUpdate,
}: ResultFormPermissionState) => readonly && (permissionLoading || !canUpdate);
